import moment from "moment-timezone"
import RoundIcon from "@/components/round-icon/round-icon.vue";

export default {
  name: 'ItemReward',
  components: {RoundIcon},
  props: {
    expiration: {
      type: Object,
      default: () => null,
      required: true
    },
    isOpenned: {
      type: Boolean,
      default: false
    },
    open: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {}
  },
  computed: {
    label() {
      console.log('type ', this.expiration.metas.TYPE_M.toLowerCase())
      return this.$t('entries.' + (this.expiration.metas.TYPE_M.toLowerCase()), {value: '' + this.expiration.label + ''})

    },
    amountNotConsumed() {
      if (this.expiration /*&& this.expiration.metas.ENTRY_CONSUMPTION_REF*/) {
        const amountExpense = Number(this.expiration.metas.ENTRY_AM_EXP);
        const distributionAmount = Number(this.expiration.amount);
        // this.expiration.metas.ENTRY_CONSUMPTION_REF.forEach(entry => {
        //   amount += entry.transactionCurrencyAmountConsumed
        // })
        const remainToBeConsumed = Number(distributionAmount - amountExpense);
        console.log('amount for distribution ', this.expiration.label, amountExpense, remainToBeConsumed)
        return remainToBeConsumed;
      }
      return 0;
    },
    amountConsumed() {
      if (this.expiration) {
        let amount = 0;
        if (this.expiration.metas.ENTRY_EXP_TRACK) {
          let exp = JSON.parse(this.expiration.metas.ENTRY_EXP_TRACK)
          console.log('entry ', exp)
          exp.forEach(entry => {
            if (entry.expirationOrChargebackType === false)
              amount += entry.transactionCurrencyAmount
          })
        } else {
          this.expiration.metas.ENTRY_CONSUMPTION_REF.forEach(entry => {
            amount += entry.transactionCurrencyAmountConsumed
          })
        }

        return amount;
        // Number(this.expiration.metas.ENTRY_AM_EXP);
      }
      return 0;
    },
  },
  methods: {
    isUrgent() {
      if (!this.expiration && !this.expiration.metas.DATE_EXPIR) return false
      const dateExpiration = new Date(this.expiration.metas.DATE_EXPIR);

      const today = new Date();

      const todayPlus30Days = new Date();
      todayPlus30Days.setDate(todayPlus30Days.getDate() + 30);

      return todayPlus30Days > dateExpiration && dateExpiration > today;
    },
    isExpired() {
      if (!this.expiration && !this.expiration.metas.DATE_EXPIR) {
        return false
      }

      let dateExpiration = new Date(this.expiration.metas.DATE_EXPIR);

      let today = new Date();
      return today > dateExpiration;
    },
    dateDistribution() {
      if (this.expiration && this.expiration.date) {
        return new Date(this.expiration.date)
      }
      // return new Date(this.expiration.date);
      return null;
    },
  }
}
